import { month_names_short } from '../components/participants/ParticipantRow';
import {changeTimeZoneToEst} from "./changeTimeZoneToEst";

export const convertEposToRenderDate = (utcSeconds: number) => {
  const d = new Date(0);
  d.setUTCSeconds(utcSeconds);
  let send_date = changeTimeZoneToEst(d);
  return `${month_names_short[send_date.getMonth()]} ${send_date.getDate()}`;
};
export const convertEposToDate = (utcSeconds: number) => {
  const d = new Date(0);
  d.setUTCSeconds(utcSeconds);
  return d;
};

export const convertEposToRenderDateWithTime = (utcSeconds: number) => {
  const d = new Date(0);
  d.setUTCSeconds(utcSeconds);
  let send_date = changeTimeZoneToEst(d);
  let hours = send_date.getHours();
  const AmOrPm = hours >= 12 ? 'PM ET' : 'AM ET';
  hours = hours % 12 || 12;
  const minutes =
      (send_date.getMinutes() < 10 ? '0' : '') +
      send_date.getMinutes();
  return `${month_names_short[send_date.getMonth()]} ${send_date.getDate()} ${
      hours + ':' + minutes + ' ' + AmOrPm
  }`;
};

export const convertDateForPackage = (date: Date) => {
  let send_date = changeTimeZoneToEst(date);
  return `${month_names_short[send_date.getMonth()]} ${send_date.getDate()}`;
};